import React, {useState} from 'react'
import './SignIn.css'
import { Link ,useHistory} from 'react-router-dom'
import { auth } from './firebase'
function SignIn() {
    const history= useHistory()
    const [name, setName]= useState('')
    const [email, setEmail]= useState('')
    const [password, setPassword]= useState('')
    const register =e=>{
        e.preventDefault()
        auth.createUserWithEmailAndPassword(email,password).then(auth=>{
            auth.user.updateProfile({
                displayName:name
            })
            history.push('/shibuCord')
        }).catch(error=>alert(error.message))
    }
    return (
        <div className="signin">
            
            <div className="si_box">
                <h1>Sign In</h1>
                <form action="">
                <p>Email Id</p>
                <input type="text" value={email} onChange={e=> setEmail(e.target.value)} />
                <p>Display Name</p>
                <input type="text" value={name} onChange={e=> setName(e.target.value)} />
                <p>Password</p>
                <input type="password" value={password} onChange={e=> setPassword(e.target.value)} />
                <h6>Dont use your usual password, I didnt spend a lot of time on the security of this App </h6>
                <button type="submit" onClick={register}>Sign In Duh</button>
            </form>
            </div>
            
        </div>
    )
}

export default SignIn
